// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___1831cca9f263b8afa0c","cls2":"ImpactHubModal-cls2___f00282618483b5daeac ImpactHubModal-cls1___1831cca9f263b8afa0c"};